import React from 'react'

const ChatIcon = (props) => {
    return (
        <svg height="20" viewBox="0 0 21 20" width="21" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd" stroke="#000" strokeLinecap="round" strokeLinejoin="round">
                <path
                    d="m16.66 3.116v7.246c0 .8-.65 1.45-1.45 1.45h-4.348l-4.347 3.623v-3.623h-2.899c-.8 0-1.45-.65-1.45-1.45v-7.246c0-.8.65-1.45 1.45-1.45h11.594c.8 0 1.45.65 1.45 1.45z"/>
                <path
                    d="m16.66 8.55c1.324-.209 2.048.008 2.173.653v5.072c0 .56-.454 1.015-1.014 1.015h-3.044l-3.043 2.536v-2.536h-2.03c-.56 0-1.014-.454-1.014-1.015v-.353"/>
            </g>
        </svg>
    )
}

export default ChatIcon

